import { useEffect } from "react";
import { Grid } from "@mui/material";
import { RenderInputByTypeMobile } from "../../../../../components/formGroupGenerator/RenderInputByTypeMobile";

export const Contrato = ({
    allowedWrite,
    isNew,
    datosSeleccionFormData,
    handleChange,
    handlePreview,
    handleChangeArchivo,
    handleDelete
}) => {

    useEffect(() => {
        handleChange('contratoCheck', datosSeleccionFormData?.contrato?.length > 0);
    }, [datosSeleccionFormData?.contrato]);

    return (
        <div className='generic-tab-container container-separate'>
            <Grid container spacing={2}>
                <Grid size={{ xs: 12 }}>
                    <div className='generic-header-tab-content-with-buttons'>
                        <strong>Contrato</strong>
                    </div>
                </Grid>
                <Grid size={{ xs: 12, sm: 8, md: 4, lg: 4 }}>
                    <RenderInputByTypeMobile
                        input={{
                            type: 'custom_switch',
                            name: 'contratoCheck',
                            displayName: 'Contrato',
                            disabled: true
                        }}
                        handleChange={handleChange}
                        value={datosSeleccionFormData.contratoCheck}
                    />
                </Grid>
                <Grid size={{ xs: 12, sm: 8, md: 6, lg: 6 }}>
                    <RenderInputByTypeMobile
                        input={{
                            type: 'file',
                            name: 'contrato',
                            displayName: 'Adjuntar contrato',
                            validExtensions: ['PNG', 'PDF', 'JPG'],
                            disabled: !allowedWrite
                        }}
                        handleChange={handleChangeArchivo}
                        handleDelete={handleDelete}
                        value={datosSeleccionFormData.contrato}
                    />
                </Grid>
            </Grid>
        </div>
    );
}